import { type ComponentPropsWithoutRef, forwardRef, memo } from 'react';

import { cn } from '@air/utils-tailwind';

export type WorkspaceSidebarSectionHeaderProps = ComponentPropsWithoutRef<'div'>;

export const WorkspaceSidebarSectionHeader = memo(
  forwardRef<HTMLDivElement, WorkspaceSidebarSectionHeaderProps>(({ className, ...restOfProps }, forwardedRef) => {
    return (
      <header
        className={cn('group/workspace-sidebar-section-header flex items-center justify-between py-1', className)}
        {...restOfProps}
        ref={forwardedRef}
      />
    );
  }),
);

WorkspaceSidebarSectionHeader.displayName = 'WorkspaceSidebarSectionHeader';
